import { QuestionnaireQueryInterface } from '@types';
import { CompaniesEnum, LangEnum, MgLocalStorageKeys } from '@enums';
import { getMgLocalStorage } from '@utils';

export type QuestionnairesPageState = {
  filters: QuestionnaireQueryInterface;
};

export const initialQuestionnairesFilters: QuestionnaireQueryInterface = {
  company: [CompaniesEnum.Vention, CompaniesEnum.Itechart],
  lang: LangEnum.ALL,
};

const localStorageFiltersData: QuestionnaireQueryInterface = getMgLocalStorage(
  MgLocalStorageKeys.QUESTIONNAIRE_FILTERS
);

export const questionnairesPageInitialState = {
  filters: localStorageFiltersData || initialQuestionnairesFilters,
};
